import type { ChangeEventHandler } from 'react';

interface CheckboxProps {
  label?: string;
  name: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export function Checkbox({
  label,
  name,
  checked,
  disabled,
  onChange,
}: CheckboxProps) {
  return (
    <label
      className={'checkbox' + (disabled ? ' disabled' : '')}
      data-qa={name}
    >
      <input
        type="checkbox"
        className="checkbox__input"
        name={name}
        checked={checked}
        onChange={onChange}
        tabIndex={disabled ? -1 : undefined}
      />
      <span className="checkbox__icon" />
      {label && <span className="checkbox__label">{label}</span>}
    </label>
  );
}
